<template>
	<div class="EditAddUser">
		<el-form v-loading="loadingPage" :model="ruleForm" ref="ruleForm" :rules="rules" @submit.prevent v-on:submit.prevent>
			<HeaderPage>
				<el-button style="height: 44px; margin-left: 1rem" native-type="submit" @click.prevent="submitForm('ruleForm')">Salvar</el-button>
				<el-dropdown v-if="ruleForm.id" trigger="click" @command="handleAction">
					<el-button type="text" icon="el-icon-more" class="el-dropdown-link"></el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item icon="el-icon-delete" command="DELETE">Excluir</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</HeaderPage>
			<el-card shadow="never">
				<el-row :gutter="20">
					<el-col :lg="12" :sm="12" :xs="24">
						<el-form-item prop="name" label="Nome">
							<el-input size="large" v-model="ruleForm.name"></el-input>
						</el-form-item>
						<el-form-item prop="email" label="E-mail">
							<el-input size="large" type="email" v-model="ruleForm.email" required></el-input>
						</el-form-item>
						<el-form-item prop="password" label="Senha">
							<el-input size="large" placeholder="● ● ● ● ● ●" v-model="ruleForm.password" :type="isPass ? 'password' : 'text'" required>
								<i
									class="el-icon-view el-input__icon"
									slot="suffix"
									@click="
										() => {
											isPass = !isPass
										}
									"
								>
								</i>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :lg="12" :sm="12" :xs="24">
						<el-form-item prop="type_account_id" label="Tipo da Conta">
							<el-select v-model="ruleForm.type_account_id" clearable style="width: 100%">
								<el-option v-if="$can('1')" :label="'Admin'" :value="1" />
								<el-option v-if="$can('1')" :label="'Marketplace'" :value="2" />
								<el-option v-if="$can('1')" :label="'Representante'" :value="4" />
								<el-option v-if="$can('1|2|4|5|6')" :label="'Estabelecimento Comercial'" :value="5" />
								<el-option v-if="$can('1')" :label="'Gerente de Marketplace'" :value="6" />
							</el-select>
						</el-form-item>

            <el-form-item
                v-if="ruleForm.type_account_id && $can('1|USER_PROFILE_MANAGER')"
                prop="authorize_profile_id"
                label="Perfil de acesso"
            >
              <SelectSearchAuthorizationProfile
                  :model="ruleForm.authorize_profile_id"
                  :isEdit="isEdit"
                  :type_account_id="ruleForm.type_account_id"
                  @handleValue="
									(x) => {
										ruleForm.authorize_profile_id = x
									}
								"
              />
            </el-form-item>

						<el-form-item v-show="ruleForm.type_account_id === 6" prop="marketplace_manager_id" label="Gerente de Marketplace">
							<SelectSearchGerenteMarketplace
								:disabled="$can('2')"
								:model="ruleForm.marketplace_manager_id"
								:isEdit="isEditGMKT"
								@handleValue="
									(x) => {
										ruleForm.marketplace_manager_id = x
									}
								"
							/>
							<br />

							<el-form-item prop="option_marketplace_manager" label="Gerencia Marketplace ?">
								<div class="block">
									<el-radio v-model="ruleForm.option_marketplace_manager" label="0" size="large"> Todos </el-radio>
									<el-radio v-model="ruleForm.option_marketplace_manager" label="1" size="large" @change="search"> Especifico </el-radio>
								</div>
							</el-form-item>
							<br />
							<el-form-item v-if="ruleForm.option_marketplace_manager === '1'" prop="selected_marketplace_manager" label="Marketplace" class="block">
								<el-select size="large" v-model="ruleForm.selected_marketplace_manager" style="width: 100%" multiple>
									<el-option v-for="item in options" :key="item.id" :label="item.person.name_store" :value="item.id">
										<span style="float: left">{{ item.person.name_store }} - {{ item.person.document }}</span>
									</el-option>
								</el-select>
							</el-form-item>
						</el-form-item>
						<el-form-item v-show="ruleForm.type_account_id === 2" prop="marketplace_id" label="Marketplace">
							<SelectSearchMarketplace
								:disabled="$can('2')"
								:model="ruleForm.marketplace_id"
								:isEdit="isEditMKT"
								@handleValue="
									(x) => {
										ruleForm.marketplace_id = x
									}
								"
							/>
						</el-form-item>
						<el-form-item v-if="ruleForm.type_account_id === 4" prop="agent_id" label="Representante">
							<SelectSearchRepresentante
								:model="ruleForm.agent_id"
								:isEdit="isEdit"
								@handleValue="
									(x) => {
										ruleForm.agent_id = x
									}
								"
							/>
						</el-form-item>
						<el-form-item v-if="ruleForm.type_account_id === 5" prop="department_store_id" label="Estabelecimento Comercial">
							<SelectSearchDepartamentStore
								:model="ruleForm.department_store_id"
								:isEdit="isEdit"
								@handleValue="
									(x) => {
										ruleForm.department_store_id = x
									}
								"
							/>
							<br />
							<el-form-item prop="multi_ec" label="Multiplos ECs ?">
								<div class="block">
									<el-radio v-model="ruleForm.multi_ec" label="0" size="large"> Não </el-radio>
									<el-radio v-model="ruleForm.multi_ec" label="1" size="large" @change="searchEcs"> Sim </el-radio>
								</div>
							</el-form-item>
							<br />
							<el-form-item v-if="ruleForm.multi_ec === '1'" prop="selected_mult_ec" label="ECS" class="block">
								<el-select size="large" v-model="ruleForm.selected_mult_ec" style="width: 100%" multiple clearable filterable :filter-method="changeEc">
									<el-option v-for="item in optionsEcs" :key="item.id" :label="item.person.name_store" :value="item.id">
										<span style="float: left">{{ item.person.name_store }} - {{ item.person.document }}</span>
									</el-option>
								</el-select>
							</el-form-item>
						</el-form-item>
					</el-col>
				</el-row>
			</el-card>
		</el-form>
	</div>
</template>

<script>
	import HeaderPage from "@/app/components/HeaderPage"
	import { getMarketplace } from "@/app/domains/Config/services"
	import { getEstaComercial } from "@/app/domains/Records/services"
	import SelectSearchRepresentante from "@/app/components/Representante/SelectSearchRepresentante"
	import SelectSearchMarketplace from "@/app/components/Marketplace/SelectSearchMarketplace"
	import SelectSearchGerenteMarketplace from "@/app/components/GerenteMarketplace/SelectSearchGerenteMarketplace"
	import SelectSearchDepartamentStore from "@/app/components/EstabelecimentoComercial/SelectSearchDepartamentStore"
  import SelectSearchAuthorizationProfile from "@/app/components/PerfilDeAcesso/SelectSearchAuthorizationProfile.vue";
  import { delUsers, getUsers, postUsers, putUsers } from "@/app/domains/Records/services"
  import { clearRuleForm, makeErrorFilds, setFormData } from "@/app/plugins/utils"
  import { mapGetters } from "vuex"

	export default {
		name: "EditAddUser",
		components: {
			HeaderPage,
      SelectSearchRepresentante,
      SelectSearchMarketplace,
      SelectSearchDepartamentStore,
      SelectSearchGerenteMarketplace,
      SelectSearchAuthorizationProfile
    },
		data() {
			const validatePass = (rule, value, callback) => {
				const regex = /^(?=.*[@!#$%^&*()/\\])(?=.*[0-9])(?=.*[a-zA-Z])[@!#$%^&*()/\\a-zA-Z0-9]{8,20}$/
				// const regex = /^(?=.*[@!#$%^&*()/\\])[@!#$%^&*()/\\a-zA-Z0-9]{8,20}$/;
				if (value === "" && !this.$route.params.id) {
					callback(new Error("Informe um senha."))
				} else if (!regex.test(String(value)) && !this.$route.params.id) {
					callback(new Error("Senhe precisa ter no minimo 8 caracter e pelo menos um caractere especial e um caractere maiúsculo."))
				} else {
					callback()
				}
			}
			return {
				loadingPage: false,
				isPass: true,
				error: {},
				options: [],
				optionsEcs: [],
				typePerson: 5,
				ruleForm: {
					name: "",
					email: "",
					password: "",
					type_account_id: "",
          authorize_profile_id: "",
					marketplace_manager_id: "",
					selected_marketplace_manager: [],
					selected_mult_ec: [],
					multi_ec: 0
				},
				rules: {
					name: [{ required: true, message: "Informe um nome.", trigger: "blur" }],
					email: [
						{ required: true, message: "Informe um e-mail.", trigger: "blur" },
						{
							type: "email",
							message: "Informe um e-mail correto.",
							trigger: ["blur", "change"]
						}
					],
					password: [
						{ validator: validatePass, trigger: "blur" }
						// { required: true, message: 'Informe um senha.', trigger: 'blur' },
						// { min: 8, max: 999, message: 'Minimo de 8 Caracteres.', trigger: 'blur' }
					]
					// type_account_id: [
					//   {required: true, message: 'Selecione um tipo de conta.', trigger: 'blur'}
					// ],
					// marketplace_id: [
					//   {required: true, message: 'Selecione um Marketplace.', trigger: 'blur'}
					// ],
					// department_store_id: [
					//   {required: true, message: 'Selecione um Estabelecimento Comercial.', trigger: 'blur'}
					// ],
					// agent_id: [
					//   {required: true, message: 'Selecione um Representante.', trigger: 'blur'}
					// ],
				},
				isEditMKT: false,
				isEditGMKT: false
			}
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						this.loadingPage = true
						this.error = {}
						try {
							let payload = {
								name: this.ruleForm.name,
								email: this.ruleForm.email,
								password: this.ruleForm.password,
								type_account_id: this.ruleForm.type_account_id,
                authorize_profile_id: this.ruleForm.authorize_profile_id,
								multi_ec: this.ruleForm.multi_ec,
								selected_mult_ec: this.ruleForm.selected_mult_ec
							}
							if (this.ruleForm.id) {
								payload.id = this.ruleForm.id
							}
							if (this.ruleForm.type_account_id === 2) {
								payload.parent_id = this.ruleForm.marketplace_id
								payload.marketplace_id = this.ruleForm.marketplace_id
							}
							if (this.ruleForm.type_account_id === 4) {
								payload.parent_id = this.ruleForm.agent_id
								payload.agent_id = this.ruleForm.agent_id
							}
							if (this.ruleForm.type_account_id === 5) {
								payload.parent_id = this.ruleForm.department_store_id
								payload.department_store_id = this.ruleForm.department_store_id
							}
							if (this.ruleForm.type_account_id === 6) {
								payload.parent_id = this.ruleForm.marketplace_manager_id
								payload.marketplace_manager_id = this.ruleForm.marketplace_manager_id
								payload.option_marketplace_manager = this.ruleForm.option_marketplace_manager

								if (payload.option_marketplace_manager == "1") {
									payload.selected_marketplace_manager = this.ruleForm.selected_marketplace_manager
								} else {
									payload.selected_marketplace_manager = []
								}
							}

							if (this.ruleForm.id) {
								//Editando
								await putUsers(payload)
								this.$message({
									showClose: true,
									message: "Registro foi editado com sucesso.",
									type: "success"
								})
								await this.$router.push({ name: "records.users.index" })
							} else {
								// Adicionando
								await postUsers(setFormData(payload))
								this.$message({
									showClose: true,
									message: "Adicionado com sucesso",
									type: "success"
								})
								await this.$router.push({ name: "records.users.index" })
							}
						} catch (e) {
							this.error = makeErrorFilds(e)
							this.$message({
								showClose: true,
								message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
								type: "error"
							})
						} finally {
							this.loadingPage = false
						}
					}
				})
			},
			async handleAction(act) {
				if (act === "DELETE") {
					this.loadingPage = true
					this.$confirm("Deseja realmente deletar este Usuário?", "Atenção", {
						confirmButtonText: "Sim",
						cancelButtonText: "Cancelar",
						center: true,
						type: "warning"
					})
						.then(async () => {
							try {
								await delUsers(this.ruleForm.id)
								await this.$router.push({ name: "records.users.index" })
								this.$message({
									showClose: true,
									message: "Usuário foi deletado.",
									type: "success"
								})
							} catch (e) {
								this.$message({
									showClose: true,
									message: e.data,
									type: "error"
								})
							} finally {
								this.loadingPage = false
							}
						})
						.catch(() => {
							this.loadingPage = false
						})
				}
			},
			async search() {
				let response = await getMarketplace("?marketplace_manager_id=" + this.ruleForm.marketplace_manager_id)
				this.options = response.data.data
			},
			async searchEcs(val = null) {

				let query = "?name_store="+val
				if (this.$can("2")) {
					query = query+"&marketplace_id=" + this.ruleForm.marketplace_id
				}
				if (this.$can("4")) {
					query = query+"&agent_id=" + this.ruleForm.agent_id
				}
				if (this.$can("5")) {
					query = query+"&department_store_id=" + this.ruleForm.department_store_id
				}
				if (this.$can("6")) {
					query = query+"&marketplace_manager_id=" + this.ruleForm.marketplace_manager_id
				}
				let response = await getEstaComercial(query)
				this.optionsEcs = response.data.data
			},
      changeEc(event){
        this.searchEcs(event);
      },
		},
		computed: {
			...mapGetters("Auth", ["currentUser"]),
			isEdit: function () {
				return !!this.ruleForm.id
			}
		},
		async beforeMount() {
			if (this.$can("2")) {
				this.isEditMKT = true
				this.ruleForm.marketplace_id = this.currentUser.marketplace_id
			}
			if (this.$can("6")) {
				this.isEditGMKT = true
			}
			this.loadingPage = true
			this.error = {}
			try {
				if (this.$route.params.id) {
					let response = await getUsers(`/${this.$route.params.id}`)
					this.ruleForm = clearRuleForm(response.data)
					console.log(response.data.multi_ec)
					console.log(response.data)
					if (response.data.multi_ec == 1) {
						this.$set(this.ruleForm, "multi_ec", '1')
						let multi_department_store_id = [...response.data.user_department_store.map((item) => item.id)];
						let responseEcs = await getEstaComercial('?multi_department_store_id='+multi_department_store_id)
						this.optionsEcs = responseEcs.data.data

						this.$set(this.ruleForm, "selected_mult_ec", [...response.data.user_department_store.map((item) => item.id)])

					}
					if (response.data.type_account_id === 2) {
						this.typePerson = 2
						this.$set(this.ruleForm, "marketplace_id", Number(response.data.marketplace_id))
						this.$set(this.ruleForm, "marketplace_manager_id", Number(response.data.marketplace_manager_id))
					}
					if (response.data.type_account_id === 4) {
						this.typePerson = 4
						this.$set(this.ruleForm, "agent_id", Number(response.data.agent_id))
					}
					if (response.data.type_account_id === 5) {
						this.typePerson = 5
						this.$set(this.ruleForm, "department_store_id", Number(response.data.department_store_id))
					}
					if (response.data.type_account_id === 6) {
						this.typePerson = 6
						this.ruleForm.option_marketplace_manager = String(this.ruleForm.option_marketplace_manager)
						this.search()
						this.$set(this.ruleForm, "selected_marketplace_manager", [...response.data.user_marketplace.map((item) => item.id)])
					}
				}
			} catch (e) {
				await this.$router.push({ name: "records.users.index" })
				this.error = makeErrorFilds(e)
				this.$message({
					showClose: true,
					message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
					type: "error"
				})
			} finally {
				this.loadingPage = false
			}
		}
	}
</script>

<style scoped></style>
